var _title, _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgChecked = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "9px",
    viewBox: "0 0 12 9",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "ECBEBE85-90A4-4330-B288-A1BBCFCAB43F")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Home",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-",
    transform: "translate(-725.000000, -2040.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Modulos-/-Epis\\xF3dio-Copy-13",
    transform: "translate(635.000000, 1888.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(87.000000, 148.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,11 C12,11.5128358 11.6139598,11.9355072 11.1166211,11.9932723 L11,12 L11,12 L7,12 C6.44771525,12 6,11.5522847 6,11 C6,10.4477153 6.44771525,10 7,10 L10,10 L10,3 C10,2.44771525 10.4477153,2 11,2 C11.5522847,2 12,2.44771525 12,3 L12,11 L12,11 Z",
    id: "Combined-Shape",
    transform: "translate(9.000000, 7.000000) rotate(-315.000000) translate(-9.000000, -7.000000) "
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgChecked, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/checked.dc74c080.svg";
export { ForwardRef as ReactComponent };